import { type ReactNode } from 'react';
import { type UserSession } from '@/api/adminApi';
import { smallBtn } from '@/components/admin/shared';

const timeAgo = (value: string) => {
    const minutes = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 60000));
    if (minutes < 1) return 'just now';
    if (minutes < 60) return `${minutes} min ago`;
    if (minutes < 1440) return `${Math.round(minutes / 60)} h ago`;
    return `${Math.round(minutes / 1440)} d ago`;
};

type Props = { sessions: UserSession[]; isLoading: boolean; onRevoke: (id: string) => void; busyId?: string | null; empty?: ReactNode };

export default function SessionsList({ sessions, isLoading, onRevoke, busyId, empty = 'No active sessions.' }: Props) {
    return (
        <div className="flex flex-col gap-2">
            {isLoading && <p className="text-sm text-grey40 dark:text-nightMuted">Loading...</p>}
            {!isLoading && sessions.length === 0 && <p className="text-sm text-grey40 dark:text-nightMuted">{empty}</p>}
            {sessions.map(session => (
                <div key={session.id} className="flex items-center justify-between gap-3 rounded-2xl px-4 py-3 ring-1 ring-black/[0.06] dark:ring-white/10">
                    <div className="min-w-0">
                        <div className="flex items-center gap-2">
                            <span className="truncate text-sm font-semibold text-grey10 dark:text-white">{session.device ?? 'Unknown device'}</span>
                            {session.current && <span className="rounded-full bg-primary99 px-2 py-0.5 text-xs font-semibold text-primary20 dark:bg-white/[0.06] dark:text-nightAccent">This device</span>}
                        </div>
                        <p className="text-xs text-grey40 dark:text-nightMuted">{session.ip ?? 'Unknown IP'} · Active {timeAgo(session.lastSeenAt)}</p>
                    </div>
                    {!session.current && <button type="button" className={smallBtn} disabled={busyId === session.id} onClick={() => onRevoke(session.id)}>Sign out</button>}
                </div>
            ))}
        </div>
    );
}
